module.exports = __webpack_public_path__ + "static/media/capsule_machine_en_ori.e9fcc633.png";